import { ErrorResponse } from '@shared/models/error.model';

import { All, AuthActionTypes } from '../actions/auth.actions';
import { BaseAuthState, initialAuthState } from '../state/auth.state';

export function authReducers(state = initialAuthState, action: All): BaseAuthState {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        result: {
          isAuthenticated: true,
          response: action.payload,
          errorResponse: new ErrorResponse(),
          storeTerminated: false
        }
      };
    }
    case AuthActionTypes.LOGIN_FAILURE: {
      return {
        ...state,
        result: {
          isAuthenticated: false,
          response: null,
          errorResponse: action.payload,
          storeTerminated: false
        }
      };
    }
    case AuthActionTypes.LOGIN_RESET: {
      return initialAuthState;
    }
    case AuthActionTypes.LOGIN_STORE_TERMINATE_ERROR: {
      return {
        ...state,
        result: {
          isAuthenticated: true,
          response: null,
          errorResponse: new ErrorResponse(),
          storeTerminated: action.payload
        }
      };
    }
    default: {
      return state;
    }
  }
}
